import { DropDownList } from '@progress/kendo-react-dropdowns';
import { FC } from 'react';
import { IS_MULTILINGUAL } from 'src/config';
import useLocaleContext from 'src/hooks/useLocaleContext';
import { LanguageCategories } from 'src/utils/constants';

interface SelectLanguageProps {}

const SelectLanguage: FC<SelectLanguageProps> = () => {
  const { selectedLanguage, handleLanguageChange, t } = useLocaleContext();

  if (!IS_MULTILINGUAL) {
    return <></>;
  }
  return (
    <div>
      <label className="text-white font-bold">{t('Select a Language') + ':'}</label>
      <DropDownList
        id="view-drop-down-list"
        style={{ width: 100 }}
        data={LanguageCategories}
        textField="label"
        dataItemKey="value"
        value={selectedLanguage}
        onChange={handleLanguageChange}
      />
    </div>
  );
};

export default SelectLanguage;
